@if (editMode) {
  <div>
    <label class="checkbox">
      <div
        fxLayout="row"
        fxLayoutAlign="start center">
        <input
          type="checkbox"
          [value]="'asLink'"
          [checked]="displayAsLink"
          (change)="setDisplayAsLink($event)"
          class="mr-3 checkbox-size" />
        <div class="checkbox-text">{{ 'COMMUNICATIONS.CONFIRMATION-AS-LINK' | translate }}</div>
      </div>
    </label>
  </div>
}
@if (!editMode) {
  <div>
    <div class="confirmation-text">{{ confirmationText }}</div>
    @if (displayAsLink) {
      <div class="confirmation-button custom-button">
        <a>{{ 'COMMUNICATIONS.MESSAGE-REPLY-HERE' | translate }}</a>
      </div>
    }
    @if (!displayAsLink) {
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="8px">
        @for (confirmationButton of confirmationButtons; track confirmationButton.uId; let i = $index) {
          <div>
            @if (confirmationButton?.type === ConfirmationType.Positive) {
              <div>
                <a
                  data-confirmation-positive
                  class="confirmation-button yes-button">
                  {{ confirmationButton.text }}
                </a>
              </div>
            }
            @if (confirmationButton?.type !== ConfirmationType.Positive) {
              <div
                data-confirmation-negative
                >
                <a
                  data-confirmation-negative
                  class="confirmation-button no-button">
                  {{ confirmationButton.text }}
                </a>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
